//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapActions } from 'vuex';
import UserSelect from '~/components/UserSelect.vue';
import constant from '~/const';

export default {
  components: {
    UserSelect,
  },

  props: {
    value: { type: Boolean, default: false },
    routerId: { type: String, default: () => '' },
  },

  data() {
    return {
      constant,
      isOld: !process.env.VUE_APP_EXCLUDE_FEATURE.includes('transactions-old'),
      version: process.env.VUE_APP_P2PAY_VERSION,
      balance: '',
      amount: null,
      userId: '',
      currencyId: null,
      comment: '',
      details: '',
      errors: {
        amount: undefined,
        currencyId: undefined,
        details: undefined,
        balance: undefined,
      },
    };
  },

  computed: {
    ...mapGetters('currencies', ['getCurrencyById']),
    ...mapState('currencies', { currenciesOld: 'currencies' }),
    ...mapState('tradersCurrencies', { currencies: 'data' }),

    getCurrencies() {
      if (this.isOld) {
        return this.currenciesOld;
      }

      switch (Number(this.version)) {
        case 2:
          return ['USDT'];
        case 1:
          return this.currencies;
        default:
          return this.currencies;
      }
    },

    isApplyDisabled() {
      const { amount, currencyId, details } = this;
      return !amount || !currencyId || !details;
    },

    model: {
      get() {
        const { value } = this;
        return value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },

  methods: {
    ...mapActions('userBalanceBalances', {
      addBalanceAction: 'addBalance',
    }),
    ...mapActions('common', [
      'setSuccessNotification',
      'setErrorNotification',
      'confirmAction',
      'setGeneralProgress',
    ]),

    validate(string, field) {
      const validators = string.split(' ');
      let inError = false;
      validators.forEach((validator) => {
        switch (validator) {
          case 'require':
            if (!this[field]) {
              inError = true;
              this.errors[field] = this.$t('This field is required.');
            } else {
              inError = false;
              this.errors[field] = '';
            }
            break;
          case 'size':
            if (this[field].length >= 1024) {
              inError = true;
              this.errors[field] = this.$t('This field can`t be more 1024 characters');
            }
            if (!inError) {
              this.errors[field] = '';
            }
            break;
          default:
            break;
        }
      });
    },

    addBalance() {
      const {
        amount,
        userId,
        currencyId,
        comment,
        details,
        routerId,
        balance,
      } = this;

      if (currencyId && amount && routerId.length > 0 && details.length > 0) {
        this.confirmAction({
          title: 'Are you sure want to add balance to user?',
          hasCancelButton: true,
          callback: async () => {
            try {
              this.setGeneralProgress(true);
              if (this.isOld) {
                await this.addBalanceAction({
                  amount,
                  currencyId,
                  comment,
                  details,
                  balance,
                  userId: !routerId ? userId : routerId,
                });
              } else {
                await this.addBalanceAction({
                  userId: !routerId ? userId : routerId,
                  balance,
                  currency: currencyId,
                  amount: Number(amount),
                  comment,
                });
              }
              this.setGeneralProgress(false);
              this.setSuccessNotification('Balance successfully sent');
              this.closeAddBalanceModal();
            } catch (error) {
              this.setErrorNotification(error);
            }
          },
        });
      } else {
        this.setErrorNotification('Required fields are empty!');
      }
    },

    closeAddBalanceModal() {
      this.amount = null;
      this.currencyId = null;
      this.balance = '';
      this.comment = '';
      this.details = '';
      this.$emit('close');
    },
  },
};
